import React from "react";
import SEOLandingPage from "../../../components/tools/SEOLandingPage";

const QuizletAlternative: React.FC = () => {
  return (
    <SEOLandingPage
      // SEO
      title="Best Quizlet Alternative 2025 - AI Flashcards & Study Tools | YouWo AI"
      metaDescription="Looking for a Quizlet alternative? YouWo AI offers AI-powered flashcard creation, spaced repetition, and smart study tools. Free to use with advanced AI features."
      keywords="quizlet alternative, quizlet competitor, free flashcard app, ai flashcards, study tool alternative, anki alternative, flashcard maker"
      canonicalUrl="https://youwo.ai/tools/quizlet-alternative"
      // Hero
      headline="The Best Quizlet Alternative for AI-Powered Learning"
      subheadline="Create flashcards 10x faster with AI. YouWo AI automatically generates study materials from your notes, lectures, and PDFs - no manual card creation needed."
      heroIcon="lucide:layers"
      heroIconColor="text-purple-500"
      heroIconBg="bg-purple-50"
      // Problem/Solution
      problemTitle="The Problem with Traditional Flashcard Apps"
      problemDescription="Creating flashcards manually is time-consuming. You spend hours typing questions and answers instead of actually studying. Plus, most apps don't help you identify what's important to learn."
      solutionTitle="AI-Powered Flashcard Generation"
      solutionDescription="YouWo AI uses advanced AI to automatically create flashcards from any content. Just paste your notes or upload a PDF, and get comprehensive study materials in seconds. Focus on learning, not creating."
      // Comparison
      competitorName="Quizlet"
      comparisonPoints={[
        { feature: "AI Flashcard Generation", youwoai: true, competitor: false },
        { feature: "PDF/Document Upload", youwoai: true, competitor: "Limited" },
        { feature: "Spaced Repetition", youwoai: true, competitor: true },
        { feature: "YouTube Video Support", youwoai: true, competitor: false },
        { feature: "Lecture Recording Support", youwoai: true, competitor: false },
        { feature: "Quiz Generation", youwoai: true, competitor: true },
        { feature: "Free AI Features", youwoai: true, competitor: false },
        { feature: "Export to Anki", youwoai: true, competitor: false },
      ]}
      // Features
      features={[
        {
          icon: "lucide:brain",
          title: "Active Recall Learning",
          description: "Flashcards use active recall - the most effective learning technique proven by science.",
        },
        {
          icon: "lucide:globe",
          title: "100+ Languages",
          description: "Create flashcards from content in over 100 languages.",
        },
        {
          icon: "lucide:file-text",
          title: "Multiple Input Sources",
          description: "Create flashcards from PDFs, lecture notes, YouTube videos, or any text content.",
        },
        {
          icon: "lucide:share-2",
          title: "Export with Pro",
          description: "Export your flashcards to Anki, Quizlet, or other apps with Pro.",
        },
        {
          icon: "lucide:zap",
          title: "Instant Generation",
          description: "Create hundreds of flashcards in seconds, not hours of manual work.",
        },
        {
          icon: "lucide:help-circle",
          title: "Quiz Mode",
          description: "Test yourself with auto-generated quizzes from your flashcard sets.",
        },
      ]}
      // CTA
      ctaText="Try YouWo AI Free"
      ctaLink="https://apps.apple.com/app/youwo-ai-agent/id6760689478"
      // Related
      relatedTools={[
        { name: "AI Flashcard Maker", href: "/tools/flashcard-maker", icon: "lucide:layers" },
        { name: "AI Quiz Generator", href: "/tools/quiz-generator", icon: "lucide:help-circle" },
        { name: "PDF Summarizer", href: "/tools/pdf-summarizer", icon: "lucide:file-text" },
        { name: "Anki Alternative", href: "/tools/anki-alternative", icon: "lucide:repeat" },
      ]}
    />
  );
};

export default QuizletAlternative;
